<template>
  <div>
    <div class="error-container align-self-center text-center">
      <b-img :src="ErrorIcon" class="align-self-center text-center error-icon-container" alt="error-icon" />
      <h3 class="my-3">Important Note</h3>
        <div class="error-message-container">
          <div class="list-item text-left">
            <ul class="warning-list list-unstyled px-4">
              <li><h4>Vendor request should go through Worksuite if -</h4></li>
              <li>1099 vendors for companies with less than three employees. This includes influencers, but not influencers that are represented by a talent agency.</li>
              <li>Worksuite site - <a class="font-weight-bold" href="https://omcmedia.worksuite.com/login/" target="_blank">Omnicom Media - Login</a></li>
            </ul>
            <ul class="warning-list list-unstyled px-4">
              <li><h4>Vendor request should go through Supplierwise if -</h4></li>
              <li>All other production/expense vendors will be used more than once</li>
              <li>Supplierwise site - <a class="font-weight-bold" href="https://inside.interpublic.com/srv/h_mass_mail/track_click.php?eid=5453&eit=599652ab64ff60837b2f34cf27b4161722c29f7c&eil=1b47ea4df24e3706a30c31b5136d583cde23f62a" target="_blank">Supplierwise</a></li>
              <li>SharePoint site -<a class="font-weight-bold" href="https://inside.interpublic.com/srv/h_mass_mail/track_click.php?eid=5453&eit=599652ab64ff60837b2f34cf27b4161722c29f7c&eil=4cef828385543a36ecbb8d3c86cceb257df004fe" target="_blank">SharePoint</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>
<style scoped>
.warning-list li {
  position: relative;
  font-size: 18px;
  word-wrap: break-word;
}
.warning-list li:first-child {
    padding-left: 15px;
}
.warning-list li:first-child:before {
    content: '';
    position: absolute;
    height: 8px;
    width: 8px;
    background:  rgba(67, 67, 67, 0.7);
    border-radius: 50%;
    top: 9px;
    bottom: auto;
    right: auto;
    left: 0;
}
.warning-list li:not(:first-child):before {
    content: '';
    position: absolute;
    height: 8px;
    width: 8px;
    border: 2px solid rgba(67, 67, 67, 0.7);
    border-radius: 50%;
    top: 9px;
    bottom: auto;
    right: auto;
    left: 30px;
}
.warning-list li:not(:first-child) {
    padding-left: 45px;
}
.error-container {
  text-align: center;
  max-width:calc(100% - 40%);
  border-radius: 5px;
  margin: 0 auto;
  margin-top:3rem !important;
  background-color: rgba(216, 216, 216, 0.2);
  padding-bottom:3.66rem;
  padding-left:1.66rem;
  padding-right:1.66rem;

}
 .error-message-container {
  margin-top: 31px;
}
.error-message-container p {
  font-family: 'Open Sans';
  font-size: 25px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.02px;
  text-align: center;
  color: #4d5161;
}
.error-icon-container {
  margin-top:3.66rem;
}
.error-message-container p {
  margin-bottom: 0px;
}
.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(50%, 50%);
}
</style>
<script>
export default {
  name: "ProdExpFormDisabled",
  data() {
    return {
      ErrorIcon: require("@/assets/Icons/Warning.svg"),
    };
  },
  created() {},
  props: {
    message: null,
  },
};
</script>

